import { render, staticRenderFns } from "./chartPatrimonies.vue?vue&type=template&id=0c9c988e&"
import script from "./chartPatrimonies.vue?vue&type=script&lang=js&"
export * from "./chartPatrimonies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports